var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconModificationRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2 1.1422H4.8C2.78398 1.1422 1.14286 2.78239 1.14286 4.79726V14.8487H11.2C13.216 14.8487 14.8571 13.2085 14.8571 11.1936V4.79726C14.8571 2.78239 13.216 1.1422 11.2 1.1422ZM11.2 0H4.8C2.1528 0 0 2.15157 0 4.79726V15.1913L4.06901e-05 15.1994V16H6.63775L6.76345 15.9909H11.2C13.8472 15.9909 16 13.8393 16 11.1936V4.79726C16 2.15157 13.8472 0 11.2 0ZM6.09529 5.56445V4.94955H6.85719V5.56445H9.14291V4.94955H9.90481V5.56445H11.0477V11.0413H4.95243V5.56445H6.09529ZM5.71434 7.6147V10.2798H10.2858V7.6147H5.71434Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModificationRequest);
export default __webpack_public_path__ + "static/media/icon--modification-request.d41b75c4e05ef2ce9f6742c2c91675e0.svg";
export { ForwardRef as ReactComponent };